/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { CheckBox, Tip } from '@insticator/insticator-ui'; // iui-materials
// types
// utils
// styles
import injectSheet from 'react-jss';
import styles from './preferselector_styles';



/* ========== ~~~~~~~~~~ PREFER SELECTOR ~~~~~~~~~~ ========== */
const PreferSelector = injectSheet(styles)((props) => {

    const { editable, selectedPaymentType, preferredPaymentType, isPaymentPreferred, onChange } = props

    return(
        <div className={`preferred-payment preferselector editable-${(editable && !(selectedPaymentType === preferredPaymentType)) && preferredPaymentType !== null} ${props.classes.preferselector}`}>
            <CheckBox handleClick={(val, e) => onChange(e)} color={`primary`} on={isPaymentPreferred} />
            <span className={`preferred-payment-copy`} >Preferred Payment Method</span>
            <Tip space={`left`} content={<p>If you check this box, this will override your current preferred payment method, and you will stop receiving payments through that method. All payments from now on will be made through this new payment method.</p>} />
        </div>
    );
            
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default PreferSelector